<template>
  <div>
    <b-form novalidate @submit.prevent="onSubmit">
      <b-row>
        <b-col xs="12" md="6">
          <b-card class="mt-3">
            <h4 slot="header">Basic</h4>
            <text-control label="ID" v-model="item.id" disabled></text-control>
            <text-control label="Name" v-model="item.displayName"></text-control>
            <text-control label="Expiration" v-model="item.stripeExpiration"></text-control>
            <text-control label="Status" v-model="item.stripeStatus"></text-control>
          </b-card>
        </b-col>
        <b-col xs="12" md="6">
          <b-card class="mt-3">
            <h4 slot="header">Stripe</h4>
            <text-control label="Subscription ID" v-model="item.stripeSubscriptionId"></text-control>
            <text-control label="Customer ID" v-model="item.stripeCustomerId"></text-control>
            <text-control label="Price ID" v-model="item.stripePriceId"></text-control>
            <text-control label="Promotion Code ID" v-model="item.stripePromotionCodeId"></text-control>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <b-button-toolbar key-nav>
            <b-button-group>
              <b-button type="submit" variant="primary">
                <slot name="save"></slot>
              </b-button>
            </b-button-group>
            <b-button-group class="mx-2">
              <b-button type="button" @click="onCancel">Cancel</b-button>
            </b-button-group>
          </b-button-toolbar>
        </b-col>
      </b-row>
          
    </b-form>
  </div>
</template>

<script>
export default {
  name: "SubscriptionFields",
  props: [
      'item'
  ],
  data() {
    return {
      jsonEditorOptions: {
        limitDragging: true,
        mode: 'view',
        modes: [
          'view',
          'code'
        ],
        enableSort: false,
        enableTransform: false
      }
    };
  },
  methods: {
    onCancel(evt) {
      this.$emit('cancel');
    },
    onSubmit(evt) {
      // Make sure all the child components are valid
      if (this.$children.every(childComponent => { return typeof(childComponent.isValid) === 'undefined' || childComponent.isValid; }))
        this.$emit('submit');
    }
  }
};
</script>